import axiosInstance from "../Utils/axiosInstance";
import { ProvincesApi } from "../Constants/api";

export const getProvincesApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${ProvincesApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
